import { render, staticRenderFns } from "./StockEditBar.vue?vue&type=template&id=1b977a95&scoped=true"
import script from "./StockEditBar.vue?vue&type=script&lang=js"
export * from "./StockEditBar.vue?vue&type=script&lang=js"
import style0 from "./StockEditBar.vue?vue&type=style&index=0&id=1b977a95&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b977a95",
  null
  
)

export default component.exports